import { supabase } from '@/integrations/supabase/client';
import type { Database } from '@/integrations/supabase/types';

type TaskInsert = Database['public']['Tables']['care_plan_tasks']['Insert'];

export const DEFAULT_SHIFT = {
  nameKey: 'defaultCare.shiftName',
  start: '08:00:00',
  end: '16:00:00',
} as const;

export interface DefaultTask {
  key: string;
  task_type: TaskInsert['task_type'];
  times: string[];
  food_type?: TaskInsert['food_type'];
  hygiene_type?: TaskInsert['hygiene_type'];
  vital_type?: TaskInsert['vital_type'];
}

export const DEFAULT_TASKS: DefaultTask[] = [
  { key: 'breakfast', task_type: 'food', food_type: 'breakfast', times: ['08:00'] },
  { key: 'lunch', task_type: 'food', food_type: 'lunch', times: ['12:00'] },
  { key: 'snack', task_type: 'food', food_type: 'snack', times: ['15:00'] },
  { key: 'bath', task_type: 'hygiene', hygiene_type: 'bath', times: ['09:00'] },
  { key: 'dressing', task_type: 'hygiene', hygiene_type: 'dressing', times: ['09:30'] },
  { key: 'bloodPressure', task_type: 'vital_sign', vital_type: 'blood_pressure', times: ['09:00', '15:00'] },
  { key: 'temperature', task_type: 'vital_sign', vital_type: 'temperature', times: ['09:00', '15:00'] },
  { key: 'activity', task_type: 'physical_activity', times: ['10:00'] },
];

const ALL_DAYS = [0, 1, 2, 3, 4, 5, 6];

export async function createDefaultCareSetup(
  patientId: string,
  userId: string,
  t: (key: string) => string,
): Promise<void> {
  const { error: shiftError } = await supabase.from('shift_templates').insert({
    patient_id: patientId,
    name: t(DEFAULT_SHIFT.nameKey),
    default_start_time: DEFAULT_SHIFT.start,
    default_end_time: DEFAULT_SHIFT.end,
    is_overnight: false,
  });
  if (shiftError) throw shiftError;

  const rows: TaskInsert[] = DEFAULT_TASKS.map((d) => ({
    patient_id: patientId,
    created_by: userId,
    name: t(`defaultCare.tasks.${d.key}`),
    task_type: d.task_type,
    food_type: d.food_type ?? null,
    hygiene_type: d.hygiene_type ?? null,
    vital_type: d.vital_type ?? null,
    schedule_times: d.times,
    schedule_days: ALL_DAYS,
    is_active: true,
    is_sporadic: false,
  }));
  const { error: taskError } = await supabase.from('care_plan_tasks').insert(rows);
  if (taskError) throw taskError;
}
